import { SliderQuery as SourceSliderQuery } from 'SourceQuery/Slider.query';
import { Field } from 'Util/Query';

export class SliderQuery extends SourceSliderQuery {
    /**
     * Extend the _getSlideFields method to include slide_text_position
     * @returns {Array}
     */
    _getSlideFields() {
        // Call the parent method to get existing fields
        const parentFields = super._getSlideFields();

        // Add slide_text_position field
        const additionalFields = ['slide_text_position', 'slide_link'];

        // Merge parent fields with the new field
        return [...parentFields, ...additionalFields];
    }
}

export default new SliderQuery();
